import { styled } from 'parkdepot-shared/theme'

export const Container = styled('div', ({ $theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    justifyContent: 'center',
    gap: $theme.sizing.scale900,
    padding: $theme.sizing.scale700,
    marginTop: '25vh'
}))

export const TitleContainer = styled('div', ({ $theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: $theme.sizing.scale600
}))

export const Title = styled('h1', ({ $theme }) => ({
    margin: 0,
    ...$theme.typography.HeadingMedium,
    textAlign: 'center'
}))

export const Subtitle = styled('p', ({ $theme }) => ({
    margin: 0,
    ...$theme.typography.ParagraphMedium,
    textAlign: 'center'
}))

export const ContentContainer = styled('div', ({ $theme }) => ({
    margin: '2rem 1.6rem',
    textAlign: 'center',

    [$theme.mediaQuery.large]: {
        margin: '2rem auto',
        minWidth: '40rem'
    }
}))

export const WemolonIcon = styled('i', ({ $theme }) => ({
    fontSize: '2.4rem',
    color: '#000',
    margin: '0 auto'
}))

export const ErrorContainer = styled('div', ({ $theme }) => ({
    ...$theme.typography.LabelLarge,
    margin: '1.6rem 0',
    fontWeight: 700
}))
